import {BodyStat} from './BodyStat';
import {Doctor} from './Doctor';

export class Patient {
  email?: string;
  name?: string;
  surname?: string;
  ssn?: string;
  birthDate?: string;
  birthPlace?: string;
  phoneNumber?: string;
  doctor?: Doctor;
  questionnaires?: string[];
  category?: string;
  pathology: string;
  checkClinicalData: boolean;


  // tslint:disable-next-line:max-line-length
  constructor(email: string, name: string, surname: string, ssn: string, birthDate: string, birthPlace: string, phoneNumber: string, doctor: Doctor, questionnaires: string[],pathology: string,checkClinicalData: boolean) {
    this.email = email;
    this.name = name;
    this.surname = surname;
    this.ssn = ssn;
    this.birthDate = birthDate;
    this.birthPlace = birthPlace;
    this.phoneNumber = phoneNumber;
    this.doctor = doctor;
    this.questionnaires = questionnaires;
    this.checkClinicalData = checkClinicalData;
    this.pathology = pathology;
  }
}
